import { useCallback } from "react";

const TextInput = ({
  value,
  onChange,
  placeholder,
  className,
  type,
  error,
  list,
}) => {
  const onChangeHandler = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <div className="flex flex-col gap-1">
      <input
        type={type ?? "text"}
        value={value}
        onChange={onChangeHandler}
        placeholder={placeholder ?? ""}
        className={className ?? ""}
        list={list}
        autoComplete={list ? "off" : undefined}
      />
      {!!error && <p className="error-content">{error}</p>}
    </div>
  );
};

export default TextInput;
